import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/pages/login/login.scss.shim.ngstyle.ts